//import React from 'react'
import { formatDate } from "../../lib/util"

const Date = ({ value }) => formatDate(value)

export default Date
